<script>
    export default {
        data() {
            return {
                windowSize: {
                    x: 0,
                    y: 0,
                }
            }
        },

        mounted () {
            this.resizeHandler();
        },

        computed: {
            actualWidth() {
                return this.windowSize.x
            },
        },


        methods: {
            resizeHandler() {
                this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            },
        }
    }
</script>